import zhCNMenu from '../zh-CN/menu';

export default {
  ...zhCNMenu,
  'menu.attraction.setting': '招商設定',
  'menu.attraction.claimConversion': '取得・商談化ルール',
  'menu.navigation.contractSettings': '契約設定',
  'menu.contractTypes': '契約種別',
  'menu.navigation.contractHandling': '契約処理',
  'menu.navigation.contractAll': 'すべての契約',
  'menu.navigation.contractMine': '自分の契約',
  'menu.navigation.contractTodo': '契約タスク',
  'menu.contractTemplates': '契約テンプレート',
  'menu.contractBillingRules': '料金計算ルール',
  'menu.navigation.module.home': 'ホーム',
  'menu.navigation.module.assets': '物件',
  'menu.navigation.module.attraction': '誘致',
  'menu.navigation.module.enterprises': '企業',
  'menu.navigation.module.reports': 'レポート',
  'menu.navigation.module.contracts': '契約',
  'menu.navigation.module.property': '施設',
  'menu.navigation.module.innovation': '企業サービス',
  'menu.navigation.module.operations': '運営',
  'menu.navigation.module.hr': '人事',
  'menu.navigation.module.finance': '財務',
  'menu.navigation.module.evaluation': '評価',
  'menu.navigation.module.settings': '設定',
  'menu.attraction.leads': 'リード',
  'menu.attraction.customers': '顧客',
  'menu.leadAll': 'すべて',
  'menu.leadMine': '我的线索',
  'menu.leadPool': '待领线索',
  'menu.customerAll': 'すべて',
  'menu.customerMine': '我的客户',
  'menu.customerPool': '待领客户',
  'menu.attraction.leadAll': '全部',
  'menu.attraction.leadMine': '我的线索',
  'menu.attraction.leadPool': '待领线索',
  'menu.attraction.customerAll': '全部',
  'menu.attraction.customerMine': '我的客户',
  'menu.attraction.customerPool': '待领客户',
  'menu.attraction.contacts': '連絡先',
  'menu.attraction.opportunities': '商談',
  'menu.workbench': 'ワークベンチ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.assets': '資産・スペース',
  'menu.business': '業務管理',
  'menu.contracts': '契約台帳',
  'menu.innovation': 'イノベーションサービス',
  'menu.hr': '人事管理',
  'menu.finance': '財務管理',
  'menu.finance.overview': '財務概要',
  'menu.finance.receivables': '売掛金管理',
  'menu.finance.receipts': '入金管理',
  'menu.finance.collectionLedger': '督促台帳',
  'menu.finance.expenses': '費用申請',
  'menu.finance.invoices': '請求書管理',
  'menu.reports': 'データレポート',
  'menu.reports.overview': 'レポート概要',
  'menu.reports.investment': '誘致レポート',
  'menu.reports.finance': '財務レポート',
  'menu.reports.property': '施設運用レポート',
  'menu.reports.settings': 'レポート設定',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.settings': 'システム設定',
  'menu.settings.permissions': '権限管理',
  'menu.settings.spaceConfig': 'スペース設定',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.park.spaceManagement': 'スペース管理',
  'menu.park.spaceManagement.spacesOverview': 'スペース概要',
  'menu.park.spaceManagement.spaces': 'スペース台帳',
  'menu.park.spaceManagement.otherAssets': 'その他の資産',
  'menu.park.spaceManagement.spaceIncubation': 'インキュベーション台帳',
  'menu.park.spaceManagement.spaceDetail': 'スペース詳細',
  'menu.park.spaceManagement.spaceUsage': 'スペース利用',
  'menu.park.property': 'ファシリティ管理',
  'menu.property': '施設',
  'menu.property.propertyDashboard': '施設管理ダッシュボード',
  'menu.property.workOrders': '施設作業依頼',
  'menu.property.propertySlaRules': '作業依頼 SLA ルール',
  'menu.property.accessControl': '入退室管理',
  'menu.property.parking': '駐車場管理',
  'menu.property.meetingRoom': '会議室管理',
  'menu.property.energy': 'エネルギー管理',
  'menu.property.energySpaces': 'スペース台帳',
  'menu.property.energyLedger': '検針台帳',
  'menu.property.energyAccounts': '企業口座',
  'menu.property.energyRates': '料金ルール',
  'menu.property.iotDevices': '接続デバイス',
  'menu.enterprises.attraction': '誘致・入居',
  'menu.attraction': '企業誘致管理',
  'menu.attraction.investmentProjects': '誘致プロジェクト',
  'menu.attraction.admissionApplications': '入居申請',
  'menu.attraction.list': '企業一覧',
  'menu.enterprises.incubation': 'インキュベーション',
  'menu.enterprises.archives': '企業アーカイブ',
  'menu.services.handling': 'サービス手続き',
  'menu.services.marketplace': 'サービス市場',
  'menu.resources.technology': '科技資源',
  'menu.portal.site': 'ポータルコンテンツ',
  'menu.portal.publish': '公開設定',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
  'menu.park': '園区',
  'menu.enterprises': '企業',
  'menu.services': 'サービス',
  'menu.operations.partyBuilding': '党建',
  'menu.operations': '運営管理',
  'menu.evaluation': '評価',
  'menu.overview': '概要',
  'menu.evaluation.overview': '概要',
  'menu.growth.archives': '成長記録',
  'menu.portal.site.banners': 'バナー',
  'menu.navigation.admission': '入居・退去',
  'menu.navigation.incubationGrowth': '育成・成長',
  'menu.navigation.resourceMatching': '資源マッチング',
  'menu.navigation.detail': '詳細',
  'menu.navigation.create': '新規作成',
  'menu.navigation.edit': '編集',
  'menu.navigation.claimReview': '企業認証審査',
  'menu.navigation.reads': '閲覧履歴',
  'menu.portal': 'ポータル管理',
  'menu.park.leases': '賃貸管理',
  'menu.todos': 'タスク一覧',
};
